// Куда встать всплывающей панели, привязанной к кнопке.
//
// Живёт отдельным модулем, а не рядом с панелью: файл, который экспортирует и
// компонент, и функцию, ломает горячую перезагрузку — она умеет обновлять
// только компоненты.

/** Где висит панель и из какого угла она растёт. */
export interface Anchor {
  top?: number
  bottom?: number
  left?: number
  right?: number
  origin: string
}

/** Ширина панели и отступ, который она держит от края экрана. */
export const PEEK_W = 352
const GUTTER = 8

/**
 * Считает положение панели по кнопке, которая её открыла.
 *
 * `above` — для кнопки в подвале боковой колонки: там панель растёт вверх,
 * иначе она ушла бы за нижний край. `below` — для плавающей кнопки сверху.
 * Оба варианта прижимаются к экрану, чтобы на телефоне панель не вылезала
 * за край, как это уже случалось с поиском по диалогам.
 */
export function anchorFrom(el: Element, place: 'above' | 'below'): Anchor {
  const r = el.getBoundingClientRect()
  const maxLeft = window.innerWidth - PEEK_W - GUTTER
  const left = Math.max(GUTTER, Math.min(r.left, maxLeft))

  if (place === 'above') {
    return {
      bottom: Math.max(GUTTER, window.innerHeight - r.top + 8),
      left,
      origin: 'bottom left',
    }
  }
  return {
    top: r.bottom + 8,
    right: Math.max(GUTTER, window.innerWidth - r.right),
    origin: 'top right',
  }
}
